import { useCallback } from 'react'
import { isFormDataRequired } from '../../../../../lib/utils/collections'
import { Modal } from 'antd'
import { toClaim, nextStage, updateFormData } from '../../../../store/order/action-creators'
import { useAppDispatch } from '../../../../hooks/useAppDispatch/useAppDispatch'
import { getStageCodeFromFormStages } from '../../../../lib/stage-conflict'

export function useSaveResult() {
  const dispatch = useAppDispatch()

  const createClaim = useCallback(async id => {
    dispatch(toClaim(id))
  }, [])

  const saveResult = useCallback(
    async (
      id,
      visibleFormData,
      _stage,
      isOpenModal,
      setIsOpenModal,
      isNextStage = false,
      stageCode?,
      stages?,
    ) => {
      if (!visibleFormData) {
        return
      }
      const from_stage = getStageCodeFromFormStages(stages || visibleFormData?.stages)
      const formData: Record<string, unknown> = {
        order: { ...visibleFormData.resultObject },
        is_next_stage: isNextStage,
        set_stage: stageCode,
      }
      if (isNextStage && from_stage) {
        formData.from_stage = from_stage
      }
      if (id === 'new' && !isNextStage) {
        const isRequiredFields = isFormDataRequired(formData.order, visibleFormData.resultSchema)
        if (!isRequiredFields) {
          return
        }
      }
      if (isNextStage || visibleFormData?.modalFieldsSchema?.re_measurement) {
        const isRequiredFields = isFormDataRequired(formData.order, visibleFormData.resultSchema)
        if (!isRequiredFields) {
          Modal.warning({
            title: 'Предупреждение',
            content: 'Заполните все обязательные поля',
          })
          return
        }
        if (visibleFormData.modal) {
          if (!isOpenModal && !visibleFormData.modalValid) {
            setIsOpenModal(true)
            return
          }
          formData.order = { ...(formData.order as object), ...visibleFormData.modalFieldsSchema }
        }
        await dispatch(nextStage(id, formData))
      } else {
        await dispatch(updateFormData(id, formData))
      }
    },
    [dispatch],
  )
  return { saveResult, createClaim }
}
